export default class Network {
  constructor(server) {
    this.serverAddress = server;
  }

  async request(method, endpoint, payload = undefined, headers = {}) {
    // Check payload type
    let body = null;
    const requestHeaders = { ...headers };

    if (!payload) {
      // If no body, make it undefined so that fetch() doesn't complain about having a payload on GET requests
      body = undefined;
    } else if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      // Don't add Content-Type header, fetch() adds it's own, which is required because it specifies the form data boundary
      body = payload;
    } else if (typeof body === 'object') {
      // Convert to JSON
      body = JSON.stringify(payload);
      requestHeaders['Content-Type'] = 'application/json';
    } else {
      // Unknown payload type, assume application/json content type, unless specified in extra headers
      body = payload;
      if (!headers['Content-Type']) requestHeaders['Content-Type'] = 'application/json';
    }

    // try get a response
    let response = null;
    let json = null;

    // Send request
    response = await fetch(this.serverAddress + endpoint, {
      method,
      body,
      headers: requestHeaders,
    });

    // Decode JSON
    json = await response.json();

    if (json.payload === undefined) {
      // Throw the error returned by the server
      const error = new Error(json.message || 'An unknown server error has occurred');
      error.code = json.error || response.status || 0;
      error.httpStatus = response.status;
      error.requestID = json.request_id;
      error.serverMessage = json.message;
      throw error;
    }

    return json.payload;
  }

  async reader(method, endpoint, payload = undefined, headers = {}) {
    // Check payload type
    let body = null;
    const requestHeaders = { ...headers };

    if (!payload) {
      // If no body, make it undefined so that fetch() doesn't complain about having a payload on GET requests
      body = undefined;
    } else if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      // Don't add Content-Type header, fetch() adds it's own, which is required because it specifies the form data boundary
      body = payload;
    } else if (typeof body === 'object') {
      // Convert to JSON
      body = JSON.stringify(payload);
      requestHeaders['Content-Type'] = 'application/json';
    } else {
      // Unknown payload type, assume application/json content type, unless specified in extra headers
      body = payload;
      if (!headers['Content-Type']) requestHeaders['Content-Type'] = 'application/json';
    }

    // Send request
    const response = await fetch(this.serverAddress + endpoint, {
      method,
      body,
      headers: requestHeaders,
    });
    return response.body.getReader();
  }
}
